// « Bugatti » + « Bugatti Baby II » → « Bugatti Baby II » : la marque n'est pas répétée quand le
// modèle commence déjà par elle (comparaison sans casse ni accents).
export function galleryHeading(make: string, model: string): string {
    const fold = (value: string) =>
        value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
    const m = fold(make);
    const md = fold(model);
    if (!m || md === m || md.startsWith(`${m} `)) {
        return model.trim();
    }
    return `${make.trim()} ${model.trim()}`;
}
